var hardBreak = function () {
    return '\n';
};
export default hardBreak;
//# sourceMappingURL=hardBreak.js.map